import { DBConfig } from 'ngx-indexed-db';
import { DQOIReferenceData } from '../models/DQOIReferenceData';
import { CommonValues } from '../static/CommonValues';

export class RefDataTableRow {
  id?: number;
  refdata: DQOIReferenceData;

  constructor(id: number, refdata: DQOIReferenceData) {
    this.id = id;
    this.refdata = refdata;
  }
}
export const dbConfig: DBConfig = {
  name: 'FjxDB',
  version: 1,
  objectStoresMeta: [{
    store: CommonValues.Database_FjxRefData,
    storeConfig: { keyPath: 'id', autoIncrement: true },
    storeSchema: [
      { name: 'refdata', keypath: 'refdata', options: { unique: false } }
    ]
  }]
};